import { render, staticRenderFns } from "./EtapaCasoView.vue?vue&type=template&id=991bbcdc"
import script from "./EtapaCasoView.vue?vue&type=script&lang=js"
export * from "./EtapaCasoView.vue?vue&type=script&lang=js"
import style0 from "./EtapaCasoView.vue?vue&type=style&index=0&id=991bbcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports